import { useTranslation } from 'react-i18next';

import { Searchbar } from '@treezor/design-system';

import { IInputField, ISelectField } from '@/ui-kit/table-filters/filters.type';
import { FormFilters } from '@/ui-kit/table-filters/FormFilters';
import { SelectFilter } from '@/ui-kit/table-filters/SelectFilter';
import { ButtonClearFilters } from '@/ui-kit/table-filters/ButtonClearFilter';

export interface IDashboardUsersFiltersProps {
  fields: {
    username?: IInputField;
    userStatus?: ISelectField;
    userRole?: ISelectField;
    twoFa?: ISelectField;
  };
  isActiveDashboardUserDisplayed?: boolean;
  clearFunction?: () => void;
}

export function DashboardUsersFilters({
  fields,
  isActiveDashboardUserDisplayed = true,
  clearFunction,
}: IDashboardUsersFiltersProps) {
  const { t } = useTranslation();

  return (
    <FormFilters testid="dashboardUsers-filters">
      <Searchbar
        size="s"
        type="text"
        placeholder={t('pages.administration.supportsUsers.table.filters.search')}
        onChange={(value: string) => fields.username.handleChange(value)}
        value={fields.username.value}
      />
      <SelectFilter field={fields.userRole} label={t('pages.administration.supportsUsers.table.filters.role')} />
      {isActiveDashboardUserDisplayed && (
        <SelectFilter field={fields.userStatus} label={t('pages.administration.supportsUsers.table.filters.status')} />
      )}
      <SelectFilter field={fields.twoFa} label={t('pages.administration.supportsUsers.table.filters.2fa')} />

      {!!clearFunction ? (
        <ButtonClearFilters
          onClick={() => {
            clearFunction();
          }}
        />
      ) : (
        <></>
      )}
    </FormFilters>
  );
}
